import api from '../utils/api';
import ActionTypes from '../constants/ActionTypes';
import { areQuestionsLoaded } from '../selectors/questions';

export const fetchQuestions = key => {
  return async (dispatch, getState) => {
    if (!key) return;
    if (areQuestionsLoaded(getState(), key)) return;

    const { data: questions } = await api.get(`/api/opus/questions/${key}`);

    return dispatch({
      type: ActionTypes.FETCH_QUESTIONS_SUCCESS,
      payload: { questions, key }
    });
  };
};
